import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Song } from '../../types';

export default function Songs() {
  const [songs, setSongs] = useState<Song[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const fetchSongs = async () => {
      const { data } = await supabase
        .from('songs')
        .select('*')
        .ilike('title', `%${search}%`)
        .order('title')
        .limit(50);
      setSongs(data || []);
      setLoading(false);
    };
    fetchSongs();
  }, [search]);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Cancionero</h1>
      
      <input
        type="text"
        placeholder="Buscar canción..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="input"
      />

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
        </div>
      ) : songs.length === 0 ? (
        <div className="card text-center py-8">
          <p className="text-[#8E8E93]">No hay canciones</p>
        </div>
      ) : (
        <div className="space-y-2">
          {songs.map((song) => (
            <Link
              key={song.id}
              to={`/songs/${song.id}`}
              className="card block  py-3"
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-white">{song.title}</h3>
                  {song.artist && <p className="text-sm text-[#8E8E93]">{song.artist}</p>}
                </div>
                {song.key && <span className="text-sm bg-primary/10 text-primary px-2 py-1 rounded">{song.key}</span>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
